import React, { useEffect, useState } from 'react'

// react-odometerjs is a client-side only package
// Dynamically import it since we're now a client-side SPA
const OdometerWrapper = ({ value, ...props }) => {
    const [Odometer, setOdometer] = useState(null)

    useEffect(() => {
        if (typeof window === 'undefined') return
        
        window.odometerOptions = {
            duration: 600
        }
        import('react-odometerjs').then((mod) => {
            setOdometer(() => mod.default)
        })
    }, [])

    if (!Odometer) {
        return <span>{value}</span>
    }

    return <Odometer value={value} {...props} />
}

export default OdometerWrapper
